import { render } from "./SaveAsPopup.vue?vue&type=template&id=59f6ce96&scoped=true&ts=true"
import script from "./SaveAsPopup.vue?vue&type=script&lang=ts"
export * from "./SaveAsPopup.vue?vue&type=script&lang=ts"

import "./SaveAsPopup.vue?vue&type=style&index=0&id=59f6ce96&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f6ce96"]])

export default __exports__